import React from 'react';
import { useParams } from 'react-router-dom';
import { Square, Flex, Loader, Stack } from '@grubhubprod/gh-cookbook-react';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
} from 'src/utilities/notifications';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { CorporateForm } from 'src/components/enterprise/features/Corporate/components/Form/CorporateForm';
import { CorporateFieldsProvider } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsProvider';
import { useCorporateEditPage } from 'src/components/enterprise/features/Corporate/EditPage/hooks/useCorporateEditPage';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { getWindow } from 'src/utilities/window';
import { EditChildCorpDescription } from 'src/components/enterprise/features/Corporate/components/EditChildCorpDescription/EditChildCorpDescription';

export const ChildCorpEditPage: React.FC = () => {
  const { corpid: corpId, childId } =
    useParams<{ corpid: string; childId: string }>();

  const onSuccess = async (): Promise<void> => {
    const window = getWindow();
    window.location.href = `${window.location.origin}/groupadmin/parents/${corpId}`;
  };

  const onError = async (
    error: IErrorResponse | SdkErrorResponse
  ): Promise<void> => {
    pushErrorFromAPI(error);
  };

  const { corpData, corpFormValues, updateCorp, getCorpLoading, getCorpError } =
    useCorporateEditPage({
      corpId: childId,
      onSuccess,
      onError,
    });

  if (getCorpError) {
    return null;
  }

  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Edit child account" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Parent accounts',
              href: `/groupadmin/parents`,
            },
            {
              label: 'Details',
              href: `/groupadmin/parents/${corpId}`,
            },
          ]}
        />
      </PageHeader>
      <Stack y="sm">
        <EditChildCorpDescription />
      </Stack>
      {getCorpLoading ? (
        <Flex justifyContent="center">
          <Loader size="lg" />
        </Flex>
      ) : (
        <CorporateFieldsProvider>
          <CorporateForm
            corpData={corpData}
            defaultValues={corpFormValues}
            onSubmit={updateCorp}
            isEditPage
          />
        </CorporateFieldsProvider>
      )}
    </Square>
  );
};
